<!--
  SuccessSheet:F-success 成功弹窗主内容(UI-SPEC §4.8)
  variant:physical(prize title 大字,无票卡)/ ticket(VS 深蓝票卡)/ concert(IMG_concert 票卡)
  T-01-04-02:v-html 仅对自身 i18n Modal.successSubtitle* 常量做 \n → <br/>,
            无用户输入风险。严禁扩展 v-html 到动态字符串。
-->
<template>
  <div
    class="success-sheet"
    :class="[`page-${pageType}`, `align-${textAlign}`, `variant-${variant}`]"
  >
    <template v-if="variant === 'physical'">
      <img class="header-image" src="../assets/baseball-success-header.png" alt="Success" />
      <div class="physical-content">
        <div class="text-content">
          <img class="title-image" src="../assets/success-all-set-text.png" :alt="t('Modal.successTitlePhysical')" />
          <p class="subtitle" v-html="subtitleHtml"></p>
        </div>
        <div class="cta">
          <button
            type="button"
            class="btn-ghost btn-physical-done"
            @click="$emit('close')"
          >
            {{ t('Modal.done') }}
          </button>
          <button
            type="button"
            class="btn-primary btn-physical-share"
            @click="$emit('share-friends')"
          >
            {{ t('Modal.bragToFriends') }}
          </button>
        </div>
      </div>
    </template>
    
    <template v-else>
      <h2 class="title">{{ titleText }}</h2>
      <!-- 仅常量字符串做 \n → <br/>;无用户输入路径 -->
      <p class="subtitle" v-html="subtitleHtml"></p>

      <div class="ticket-area">
        <TicketPreviewCard
          :page-type="pageType"
          :variant="variant"
          :rows="rows"
          :home-team="homeTeam"
          :away-team="awayTeam"
        />
      </div>

      <div
        v-if="state === 'success'"
        class="cta"
      >
        <button
          type="button"
          class="btn-ghost"
          @click="$emit('close')"
        >
          {{ t('Modal.close') }}
        </button>
        <button
          type="button"
          class="btn-primary"
          @click="$emit('share-friends')"
        >
          {{ t('Modal.shareFriends') }}
        </button>
      </div>
      <div
        v-else
        class="cta cta-single"
      >
        <button
          type="button"
          class="btn-primary"
          @click="$emit('close')"
        >
          {{ t('Modal.gotIt') }}
        </button>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import TicketPreviewCard from './TicketPreviewCard.vue';
import t from '../utils/i18n';
type Row = {
  label: string;
  value: string;
};
type Props = {
  pageType: 'PC' | 'H5';
  variant: 'physical' | 'ticket' | 'concert';
  prizeTitle: string;
  rows: Row[];
  homeTeam?: string;
  awayTeam?: string;
  subtitleKey: 'successSubtitleTicket' | 'successSubtitleConcert' | 'successSubtitlePhysical';
  textAlign?: 'center' | 'left';
  state?: 'success' | 'sold-out';
};
const __sfc_main = {};
__sfc_main.props = {
  pageType: {
    key: "pageType",
    required: true,
    type: String
  },
  variant: {
    key: "variant",
    required: true,
    type: String
  },
  prizeTitle: {
    key: "prizeTitle",
    required: true,
    type: String
  },
  rows: {
    key: "rows",
    required: true,
    type: Array
  },
  homeTeam: {
    key: "homeTeam",
    required: false,
    type: String
  },
  awayTeam: {
    key: "awayTeam",
    required: false,
    type: String
  },
  subtitleKey: {
    key: "subtitleKey",
    required: true,
    type: String
  },
  textAlign: {
    key: "textAlign",
    required: false,
    type: String,
    default: 'center'
  },
  state: {
    key: "state",
    required: false,
    type: String,
    default: 'success'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  // 仅对 i18n 常量字符串的 \n 做替换,**无用户输入**(T-01-04-02 accept)
  const subtitleHtml = computed(() => {
    const raw = props.state === 'sold-out' ? String(t('Modal.wishlistHint')) : String(t(`Modal.${props.subtitleKey}`));
    return raw.replace(/\n/g, '<br/>');
  });
  const titleText = computed(() => props.state === 'sold-out' ? String(t('Modal.wishlistTitle')) : String(t('Modal.successTitle')));
  return {
    t,
    subtitleHtml,
    titleText
  };
};
__sfc_main.components = Object.assign({
  TicketPreviewCard
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped>
.success-sheet {
  display: flex;
  flex-direction: column;
}
.ticket-area {
  display: flex;
  flex-direction: column;
}
.info-panel {
  background: #f3f3f5;
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.row-label {
  color: #7a7a7a;
}
.row-value {
  color: #000000;
}
.prize-title-large {
  font-weight: 600;
  text-align: center;
}

.btn-primary {
  background: #ff6900;
  color: #ffffff;
  border: none;
  cursor: pointer;
  font-family: BR Hendrix, Arial, sans-serif;
}
.btn-ghost {
  background: transparent;
  color: #1d1d1d;
  cursor: pointer;
  font-family: BR Hendrix, Arial, sans-serif;
}

.header-image {
  width: 100%;
  height: auto;
  display: block;
}

/* ─── H5(rem)UI-SPEC §4.8.a ──────────────────────────── */
.success-sheet.page-H5:not(.variant-physical) {
  gap: 0.16rem;
}
.success-sheet.page-H5.variant-physical {
  gap: 0;
  overflow: hidden;
  border-radius: 0.3077rem 0.3077rem 0 0;
  background: #ffffff;
}
.page-H5.variant-physical .header-image {
  width: 100%;
  height: 3.16rem;
  object-fit: cover;
  object-position: center top;
  border-radius: 0.3077rem 0.3077rem 0 0;
  position: relative;
  z-index: 0;
}
.page-H5.variant-physical .physical-content {
  padding: 0.4rem 0.4rem 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.48rem;
}
.page-H5.variant-physical .text-content {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: center;
}
.page-H5.variant-physical .title-image {
  width: auto;
  height: 0.5rem;
  display: block;
}
.page-H5 .title {
  font-weight: 600;
  font-size: 0.5rem;
  line-height: 1.1em;
  color: #262626;
  margin: 0;
  padding: 0 0.4rem;
  text-align: center;
}
.page-H5.variant-physical .title {
  display: none;
}
.page-H5 .subtitle {
  font-weight: 400;
  font-size: 0.3rem;
  line-height: 1.4em;
  color: #626262;
  padding: 0 0.4rem;
  margin: 0;
  text-align: center;
}
.page-H5.variant-physical .subtitle {
  font-size: 0.3rem;
  color: #525252;
  padding: 0;
  text-align: center;
}
.page-H5.variant-physical .cta {
  padding: 0;
  justify-content: center;
}
.page-H5 .ticket-area {
  padding: 0.12rem 0.4rem 0.26rem;
  gap: 0.24rem;
}
.page-H5 .prize-title-large {
  font-size: 0.4rem;
}
.page-H5 .ticket-card {
  width: 6.54rem;
  min-height: 2rem;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.page-H5 .ticket-card.variant-ticket {
  background: #0041ac;
  min-height: 3.16rem;
}
.page-H5 .ticket-card.variant-concert {
  background: linear-gradient(135deg, #0a489d, #042258);
  min-height: 2rem;
}
.page-H5 .info-panel {
  border: 2px solid #dedede;
  border-radius: 0.2rem;
  padding: 0.3rem 0.2rem;
  gap: 0.24rem;
}
.page-H5 .row-label,
.page-H5 .row-value {
  font-size: 0.24rem;
  font-weight: 400;
}
.page-H5 .cta {
  display: flex;
  justify-content: space-between;
  padding: 0.23rem 0.4rem;
  gap: 0.19rem;
}
.page-H5 .btn-ghost {
  width: 2.04rem;
  height: 0.9rem;
  border-radius: 2.24rem;
  border: 2px solid #1d1d1d;
  font-weight: 600;
  font-size: 0.36rem;
}
.page-H5 .btn-primary {
  width: 4.54rem;
  height: 0.9rem;
  border-radius: 0.8rem;
  font-weight: 600;
  font-size: 0.36rem;
}

/* ─── PC UI-SPEC §4.8.b ──────────────────────────────── */
.success-sheet.page-PC:not(.variant-physical) {
  gap: 20px;
}
.success-sheet.page-PC.variant-physical {
  gap: 0;
  overflow: hidden;
  border-radius: 20px;
  background: #ffffff;
}
.page-PC.variant-physical .header-image {
  width: 100%;
  height: 240px;
  object-fit: cover;
  object-position: center top;
  border-radius: 20px 20px 0 0;
}
.page-PC.variant-physical .physical-content {
  padding: 32px 30px 40px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.page-PC.variant-physical .text-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}
.page-PC.variant-physical .title-image {
  width: auto;
  height: 48px;
  display: block;
}
.page-PC .title {
  font-weight: 600;
  font-size: 28px;
  line-height: 1.2;
  color: #000000;
  margin: 0;
  text-align: center;
}
.page-PC.variant-physical .title {
  display: none;
}
.page-PC .subtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 1.4;
  color: #626262;
  margin: 0;
  text-align: center;
}
.page-PC.variant-physical .subtitle {
  font-size: 20px;
  line-height: 1.4em;
  letter-spacing: -0.02em;
  color: #525252;
  text-align: center;
}
.page-PC.variant-physical .cta {
  padding: 0;
  display: flex;
  justify-content: center;
}
.page-PC .ticket-area {
  gap: 20px;
  align-items: center;
}
.page-PC .prize-title-large {
  font-size: 24px;
}
.page-PC .ticket-card {
  width: 350px;
  height: 240px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.page-PC .ticket-card.variant-ticket {
  background: #0041ac;
}
.page-PC .ticket-card.variant-concert {
  background: linear-gradient(135deg, #0a489d, #042258);
}
.page-PC .info-panel {
  width: 350px;
  border-radius: 20px;
  padding: 32px 24px;
  gap: 16px;
}
.page-PC .row-label {
  font-size: 16px;
}
.page-PC .row-value {
  font-size: 20px;
  font-weight: 600;
}
.page-PC .cta {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.page-PC .cta-single {
  gap: 0;
}
.page-PC .btn-ghost {
  width: 160px;
  height: 60px;
  border-radius: 60px;
  border: 1px solid #1d1d1d;
  font-weight: 600;
  font-size: 24px;
}
.page-PC .btn-primary {
  width: 280px;
  height: 60px;
  border-radius: 60px;
  font-weight: 600;
  font-size: 24px;
}

.align-left .title,
.align-left .subtitle {
  text-align: left;
}
</style>
